// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_7z-3";
export var contentContainer = "_7z-0";
export var editorContainer = "_7z-1";
export var quillInputForm = "_7z-2";
export var zoneDivider = "_7z-4";